import { create } from "zustand";
import type { GetConfigResponse, CheckMissionResponse } from "@/client";

type Match = GetConfigResponse["matches"][number];

type AppState = {
  updateState: <K extends keyof AppState>(key: K, value: AppState[K]) => void;
  loaded?: boolean;
  userLoaded?: boolean;
  delta?: number;
  errors?: { [key: string]: string };
  loginSuccess?: boolean;
  params?: { [key: string]: string }[];
  isCallingApi?: boolean;
  isSpining?: boolean;

  selectedMatch?: Match | null;
  completedMissions?: CheckMissionResponse['completedMissions'] | null;
  modalMissionStatus?: boolean;
  modalPredictMatchStatus?: boolean;
  getParam: (key: string) => string;
  getError: (error: any) => string;
};

export const useStore = create<AppState>((set, get) => ({
  loaded: false,
  userLoaded: false,
  delta: 0,
  errors: {},
  params: [],
  loginSuccess: false,
  isCallingApi: false,
  isSpining: false,

  selectedMatch: null,
  completedMissions: null,
  modalMissionStatus: false,
  modalPredictMatchStatus: false,

  getParam: (key: string) => {
    const params = get().params;
    return params?.[key as any] as any;
  },
  getError: (error: any) => {
    const errors = get().errors;
    const key = (error?.message || error?.code) as string;
    return (
      errors?.[key] || `Hệ thống chưa thể thực hiện thao tác của bạn: ${key}`
    );
  },

  updateState: (key, value) => set({ [key]: value }),
}));
